import { addCvImage } from '../../../../../Maker/F/CvImage/fs.js';
import { getCurrentFcanvas } from '../../../../../Maker/F/Fcanvas/cv_object.js';
import { BpOptionConstantS } from '../../../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { NewMakerFitPrintWidthF } from '../../../../FitPrintWidth/F/Function/module/NewMakerFitPrintWidthF.js';
import { BpOptionF } from '../../../../../BpOption/F/Function/module/BpOptionF.js';
import { OMPDosuF } from '../../../../../OMP/Dosu/F/Function/module/OMPDosuF.js';
import { NewMakerPropertyBaseProductF } from '../../../../Property/BaseProduct/F/Function/module/NewMakerPropertyBaseProductF.js';

export const addCvImageToMpMaker = async (image) => {
  const cv_image = await addCvImage({
    image,
    before_add_to_fcanvas: (cv_image) => {
      const fcanvas = getCurrentFcanvas();
      if (fcanvas?.fcanvas_data?.maker_type === BpOptionConstantS.MASKING_TAPE_EDITOR) {
        NewMakerFitPrintWidthF.activateFitToPrintWidth(cv_image, fcanvas);
      }
    },
  });
  const canvas = G.mp.maker.editing_canvas();
  const dosu_ctn = BpOptionF.biz.get.currentFace.maxDosuCount(canvas.bpf_id);
  if (cv_image && dosu_ctn) {
    const dosu_confirm = await OMPDosuF.dosu_confirm.isMoreThanLimitedDosu(canvas.bpf_id, [cv_image]);
    if (dosu_confirm !== undefined) {
      if (dosu_confirm) {
        await G.mp.maker.modified();
        await NewMakerPropertyBaseProductF.linkToBpId.goTo();
      } else {
        cv_image.remove();
      }
      $.don_loader_end();
      return;
    }
  }
  if (cv_image) await G.mp.maker.modified();
  return cv_image;
};
